/**
 * Given an IntersectionObserver entry, returns whether the observed element has
 * been scrolled ABOVE the viewport — i.e. the user has scrolled past it — as
 * opposed to it still being below the fold (not yet reached).
 *
 * Used to decide when the mobile sticky buy box bar may appear: it should only
 * show once the buy box area is above the viewport, never while it is still
 * below the fold on load.
 */
export const hasScrolledPastElement = (entry: {
  isIntersecting: boolean
  boundingClientRect: { top: number }
}): boolean => !entry.isIntersecting && entry.boundingClientRect.top < 0
